import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useDerivedState = function useDerivedState(initialValue, derivedValue) {
  // We have to call this no matter what, but we only use it if value is local state
  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];

  var _useState3 = useState(derivedValue !== undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      isDerived = _useState4[0],
      setIsDerived = _useState4[1]; // A component can move from local to derived state, but never derived to local state. Ideally this should
  // never happen, but it's easy to see a scenario where someone passes a value from an uninitialized useState call, so
  // I thought it was prudent to support this scenario. We also reset stateValue to initialValue to remove any
  // lingering state modifications.


  useEffect(function () {
    // if derivedValue isn't undefined, it means we need to move to derived state
    if (!isDerived && derivedValue !== undefined) {
      setIsDerived(true);
      setStateValue(initialValue);
    }
  }, [derivedValue, isDerived, initialValue]);

  function noopUpdater() {
    /* not using noop util here as we don't want a return value */
  }

  var value = isDerived ? derivedValue : stateValue;
  var updater = isDerived ? noopUpdater : setStateValue;
  return [value, updater, isDerived];
};

var useDerivedState$1 = useDerivedState;

export { useDerivedState$1 as default };
